import { render } from "./MarketplaceHome.vue?vue&type=template&id=70a78943&scoped=true"
import script from "./MarketplaceHome.vue?vue&type=script&lang=js"
export * from "./MarketplaceHome.vue?vue&type=script&lang=js"

import "./MarketplaceHome.vue?vue&type=style&index=0&id=70a78943&lang=css"
import "./MarketplaceHome.vue?vue&type=style&index=1&id=70a78943&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a78943"]])

export default __exports__